import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, A11y } from 'swiper/modules';

const FADE_SPEED_MS = 900;

export default function ShowroomTileCarousel({ slides }) {
  const handleSlideChange = useCallback(
    swiper => {
      const slide = slides[swiper.realIndex];
      if (!slide || !swiper.params.autoplay) return;
      swiper.params.autoplay.delay = slide.durationMs;
      swiper.autoplay.stop();
      swiper.autoplay.start();
    },
    [slides],
  );

  if (!slides?.length) return null;

  return (
    <Box
      className="showroom-tile-carousel"
      sx={{
        position: 'absolute',
        inset: 0,
        overflow: 'hidden',
      }}
      aria-hidden
    >
      <Swiper
        className="showroom-tile-swiper"
        modules={[Autoplay, EffectFade, A11y]}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        speed={FADE_SPEED_MS}
        loop
        allowTouchMove={false}
        autoplay={{
          delay: slides[0].durationMs,
          disableOnInteraction: false,
        }}
        onSlideChange={handleSlideChange}
        style={{ width: '100%', height: '100%' }}
      >
        {slides.map(item => (
          <SwiperSlide key={item.id}>
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                height: '100%',
                '--showroom-slide-duration': `${item.durationMs}ms`,
              }}
            >
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                className="showroom-tile-bg-image"
                src={item.imageUrl}
                alt={item.alt}
                style={{
                  position: 'absolute',
                  inset: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
}

ShowroomTileCarousel.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      imageUrl: PropTypes.string.isRequired,
      alt: PropTypes.string,
      durationMs: PropTypes.number,
    }),
  ).isRequired,
};
